import React from 'react';
import NemCtrl from './NemCtrl.js';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
/*
const constants = {
  colorRed: "#d62631", 
  colorWhite: "#ffffff",
  colorGray: "#dedede", 
}
*/

export default class RothRadioButton extends NemCtrl {
  style = {
    default: {},
  };
  optionStyle = {
    textAlign: 'right',
    textShadow: '-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white',
  };
  handleChange = (event, value) => {
    if ('fn' in this.props) {
      if ('param' in this.props && 'value' in this.props) this.props.fn(this.props.param, value);
      else if ('param' in this.props) this.props.fn(this.props.param);
      else if ('value' in this.props) this.props.fn(value);
      else this.props.fn();
    }
  };
  renderOptions = () => {
    var _this = this;
    return Object.keys(_this.props.options).map(function(option) {
      return (
        <RadioButton
          className="RadioButton"
          style={_this.optionStyle}
          labelStyle={{ textAlign: 'right', float: 'right', marginRight: '-20px' }}
          key={option}
          value={option}
          label={_this.props.options[option]}
        />
      );
    });
  };
  render = () => {
    var group = (
      <RadioButtonGroup
        name={this.props.param}
        style={this.getStyle()}
        labelPosition="left"
        defaultSelected={this.props.value}
        onChange={this.handleChange}
      >
        {this.renderOptions()}
      </RadioButtonGroup>
    );
    return group;
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/RothRadioButton.js
 **/